<template>
  <div class="rights-box">
    <van-collapse class="collapse-box" :border="false" v-model="activeNames" @change="changeCollapse">
        <van-collapse-item class="collapse-item-box" :border="false" v-for="(item, index) in rightsList" :key="index" :name="index+1">
            <template #title>
               <div class="title-box"><van-icon class="icon" :name="item.icon" /><span class="tit">{{item.title}}</span></div>
            </template>
            <template #right-icon>
                <van-icon :class="['right-box', IsOpen(index + 1) ? 'right-box-top' : 'right-box-down']" name="arrow-up" color="#B2B2B2" />
            </template>
            <div class="cont">
                <img class="pic" :src="item.content" alt="">
            </div>
        </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { Collapse, CollapseItem, Icon } from 'vant';

export default {
    name: 'newForStudentsRights',
    components: {
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Icon.name]: Icon
    },
    props: {
        activeItems: {
            type: Array,
            default: () => []
        },
        listLength: {
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            activeNames: [1],
            clickIndex: '',
            rightsList: [
                {
                    id: 1,
                    icon: '//file.40017.cn/appresource/image/forStudent/new/img_title1@3x.png',
                    title: '单单返现 最高45元',
                    content: '//file.40017.cn/appresource/image/forStudent/new/img_cont1.png'
                },{
                    id: 2,
                    icon: '//file.40017.cn/appresource/image/forStudent/new/img_title2@3x.png',
                    title: '出行省钱学生卡 价值1000元',
                    content: '//file.40017.cn/appresource/image/forStudent/new/img_cont2@3x.png'
                },{
                    id: 3,
                    icon: '//file.40017.cn/appresource/image/forStudent/new/img_title3@3x.png',
                    title: '学生价 火车票5折起',
                    content: '//file.40017.cn/appresource/image/forStudent/new/img_cont3@3x.png'
                },{
                    id: 4,
                    icon: '//file.40017.cn/appresource/image/forStudent/new/img_title4@3x.png',
                    title: '学生价 机票最高立省20%',
                    content: '//file.40017.cn/appresource/image/forStudent/new/bg_cont.png'
                },{
                    id: 5,
                    icon: '//file.40017.cn/appresource/image/forStudent/new/img_title5@3x.png',
                    title: '学生价 酒店82折起',
                    content: '//file.40017.cn/appresource/image/forStudent/new/img_cont5@3x.png'
                }

            ]
        }
    },
    mounted() {
        this.activeNames = this.activeItems
        this.rightsList = this.rightsList.slice(0, this.listLength)
    },
    methods: {
        IsOpen(i) {
            // console.log('1-----', i)
            // console.log('2-----', this.activeNames)
            if (this.activeNames.includes(i)) {
               return true 
            }
        },
        getTitle(i) {
            let title = ''
            switch (i) {
                case 1:
                    title = '权益一'
                    break;
                case 2:
                    title = '权益二'
                    break;
                case 3:
                    title = '权益三'
                    break;
                case 4:
                    title = '权益四'
                    break;
                case 5:
                    title = '权益五'
                    break;
                default:
                    break;
            }
            return title
        },
        arrayAminusB(arrA, arrB) {
            const result = arrA.filter(v => !arrB.includes(v))
            return result[0]
        },
        changeCollapse(val) {
            // console.log('13333-----', val, this.activeNames)
            if (val.length > this.activeNames.length) {
                this.clickIndex = this.arrayAminusB(val, this.activeNames)
            } else {
                this.clickIndex = this.arrayAminusB(this.activeNames, val)
            }
            // console.log('14444-----', this.clickIndex, this.IsOpen(this.clickIndex) ? '收起' : '展开');
            this.$emit('setTracked', {
                action: 'before_rightscontent_click',
                label: '认证前权益内容点击',
                value: {"channel":"学生专区","scene":"公共","content": this.getTitle(this.clickIndex), state: this.IsOpen(this.clickIndex) ? '收起' : '展开'}
            })
        }
    }
}
</script>

<style lang="less" scoped>
.rights-box {
    .collapse-box {
        ::v-deep .van-collapse-item__title {
            display: flex;
            align-items: center;
            // border-radius: 8px;
            padding: 0;
        }
        // ::v-deep .van-collapse-item__title--expanded {
        //     border-radius: 8px 8px 0 0;
        // }
        ::v-deep .van-collapse-item__content {
            // border-radius: 0 0 8px 8px;
            padding: 12px;
            background: #F0FBFC;
        }
        .collapse-item-box {
            margin: 0 12px 12px;
            border-radius: 8px;
            overflow: hidden;
        }
    }
    .title-box {
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        .icon {
            margin-right: 12px;
            img{
                width: 78px;
                height: 46px;
            }
        }
        .tit {
            padding-top: 2px;
        }
    }
    .right-box {
        margin-right: 12px;
    }
    .right-box-top {
        transform: rotate(0deg);
        transition: transform 0.3s;
    }

    .right-box-down {
        transform: rotate(180deg);
        transition: transform 0.3s;
    }

    .cont {
        .pic {
            width: 327px;
            object-fit: contain;
            margin: 0 auto;
        }
    }
}
</style>>
